import { render, staticRenderFns } from "./orderTagScanList.vue?vue&type=template&id=68b6c0de&scoped=true&"
import script from "./orderTagScanList.vue?vue&type=script&lang=js&"
export * from "./orderTagScanList.vue?vue&type=script&lang=js&"
import style0 from "./orderTagScanList.vue?vue&type=style&index=0&id=68b6c0de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b6c0de",
  null
  
)

export default component.exports